import { SharedModule } from 'Public_old/src/app/appShares.module';
import { LicenceHolderFooterComponent } from 'Public_old/src/app/Views/licenceholder-footer.component';
import { NgModule } from '@angular/core';
import { AnonymousChatWrapper } from './anonymous-chat.wrapper';
import { AttentionCardWrapper } from './attention-card.wrapper';
import { BookingWrapper } from './booking.wrapper';
import { CareCompanionWrapper } from './care-companion.wrapper';
import { CareNavigationWrapper } from './care-navigation.wrapper';
import { ChangeUnitWrapperComponent } from './change-unit.wrapper';
import { CookiePolicyWrapperComponent } from './cookie_policy.wrapper';
import { CreateNewMessageWrapper } from './create-new-message.wrapper';
import { DeviceGatewayWrapperComponent } from './device-gateway.wrapper';
import { FooterWrapperComponent } from './footer.wrapper';
import { HeaderWrapperComponent } from './header.wrapper';
import { HomeWrapperComponent } from './home.wrapper';
import { LanguageSelectWrapperComponent } from './language_select.wrapper';
import { MyAccountWrapperComponent } from './my_account.wrapper';
import { PopoverManagerComponent } from './popover_manager.wrapper';
import { PrivacyPolicyWrapperComponent } from './privacy_policy.wrapper';
import { ReceptionHomeWrapperComponent } from './reception-home.wrapper';
import { RedRobinWrapper } from './red_robin.wrapper';
import { SignInWrapperComponent } from './sign-in.wrapper';
import { SignInFinishWrapperComponent } from './sign-in-finish.wrapper';
import { SignInModalWrapperComponent } from './sign-in-modal.wrapper';
import { TermsOfServiceWrapperComponent } from './terms_of_service.wrapper';
import { VisitsWrapperComponent } from './visits.wrapper';

@NgModule({
	imports: [SharedModule],
	declarations: [
		LicenceHolderFooterComponent,
		HomeWrapperComponent,
		FooterWrapperComponent,
		HeaderWrapperComponent,
		PopoverManagerComponent,
		AttentionCardWrapper,
		ChangeUnitWrapperComponent,
		VisitsWrapperComponent,
		DeviceGatewayWrapperComponent,
		LanguageSelectWrapperComponent,
		CookiePolicyWrapperComponent,
		ReceptionHomeWrapperComponent,
		RedRobinWrapper,
		MyAccountWrapperComponent,
		SignInWrapperComponent,
		SignInModalWrapperComponent,
		SignInFinishWrapperComponent,
		CreateNewMessageWrapper,
		AnonymousChatWrapper,
		BookingWrapper,
		CareCompanionWrapper,
		PrivacyPolicyWrapperComponent,
		TermsOfServiceWrapperComponent,
		CareNavigationWrapper,
	],
	exports: [
		LicenceHolderFooterComponent,
		HomeWrapperComponent,
		FooterWrapperComponent,
		HeaderWrapperComponent,
		PopoverManagerComponent,
		AttentionCardWrapper,
		ChangeUnitWrapperComponent,
		VisitsWrapperComponent,
		DeviceGatewayWrapperComponent,
		LanguageSelectWrapperComponent,
		CookiePolicyWrapperComponent,
		ReceptionHomeWrapperComponent,
		RedRobinWrapper,
		MyAccountWrapperComponent,
		SignInWrapperComponent,
		SignInModalWrapperComponent,
		SignInFinishWrapperComponent,
		CreateNewMessageWrapper,
		AnonymousChatWrapper,
		BookingWrapper,
		CareCompanionWrapper,
		PrivacyPolicyWrapperComponent,
		TermsOfServiceWrapperComponent,
		CareNavigationWrapper,
	],
	providers: [],
})
export class WrappersModule {}
